import { combineReducers } from "redux";
import commonReducer from "./common";
import commonReloadReducer from "./common_reload";
import cartReducer from "./cart";
import orderReducer from "./order";
import settingsReducer from "./settings";

const rootReducer = combineReducers({
  commonReducer,
  commonReloadReducer,
  cartReducer,
  orderReducer,
  settingsReducer,
});

export default rootReducer;
